import { styled, css } from 'styled-components';
import { colors, getFontWeight } from '../../../../abstracts';
import { StyledHeader } from '../../common';
import { dontForwardProps } from '../../../../util';
import { StyledDescriptionDetails } from './styledDescriptionDetails';
import { StyledRow } from './styledRow';
import { StyledDescriptionList } from './styledDescriptionList';
const StyledList = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-4d2zgn-0"
})(["", "{text-align:right;font-weight:", ";}", ";", ";", ";margin-bottom:1rem;"], StyledDescriptionDetails, ({
  hasDescriptionEmphasis
}) => hasDescriptionEmphasis ? getFontWeight('heavy') : 'inherit', ({
  isCard
}) => isCard && css(["background:", ";box-shadow:0 0.25rem 1.875rem rgba(0,0,0,0.2);border-radius:0.5rem;padding-top:1.5rem;", "{padding-left:1rem;padding-right:1rem;}", "{padding-left:1rem;padding-right:1rem;}"], colors.white, StyledHeader, StyledRow), ({
  isSpacingCompact
}) => {
  const paddingBottom = isSpacingCompact ? `1rem` : `1.5rem`;
  return css(["", ",", "{padding-bottom:", ";}"], StyledHeader, StyledRow, paddingBottom);
}, ({
  hasDividers,
  isSpacingCompact
}) => {
  const paddingTop = isSpacingCompact ? `1rem` : `1.5rem`;
  const marginTop = hasDividers ? paddingTop : `0`;
  return css(["", ",", "{margin-top:", ";}", "{padding-top:", ";}"], StyledHeader, StyledRow, marginTop, StyledDescriptionList, paddingTop);
});
export { StyledList };